<template>
  <div class="container">

    <div class="container-fluid" style="padding-bottom: 10px;">
      <h4 v-if="meta" class="mb-5">{{ meta.translation['en'].name }}</h4>

      <div v-for="record in dateExport" :key="record.id" class="mb-5">
        <h5 style="font-size: 1.2rem">{{ record.name }}</h5>
        <div class="ml-4 mt-3" v-for="item in record.steps" :key="item.id">
          <h5 style="font-size: 1.0rem">{{ item.name }}</h5>
          <div class="ml-4 mt-3" v-for="last in item.steps" :key="last.id">
            <h5 style="font-size: 1.0rem">

              <span>{{ last.name }}</span>
              <div v-if="last.name == 'Income chart' && incomeCategory" class="mt-4 pt-4">
                <BudgetSection :show-items="false" :cat="incomeCategory" :budget="defaultBudget"
                               :key="incomeCategory.id"></BudgetSection>
              </div>

              <div class="mt-4 pt-4" v-if="last.name == 'Costs chart' && expensesCategory">
                <BudgetSection  :show-items="false" :cat="expensesCategory" :budget="defaultBudget"
                               :key="expensesCategory.id"></BudgetSection>
              </div>
              <div class="mt-4 pt-4" v-if="last.name == 'Summary chart' && defaultBudget">
                <BudgetSummary :budget="defaultBudget">
                </BudgetSummary>
              </div>

            </h5>
            <div class="ml-4 mt-3" v-for="section in last.sections" :key="section.id">
              <h5 style="font-size: 1.0rem">{{ section.name }}</h5>

              <div style="position: relative;">
                <div v-if="section.last && section.last != ''&& section.last != ''" class="card p-4" v-html="section.last"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import BudgetSummary from "./Budget/BudgetSummary.vue";
import BudgetSection from "./Budget/BudgetSection.vue"

export default {
  name: 'GeneratePlan',
  components: {BudgetSummary, BudgetSection},
  data() {
    return {
      dateExport: [],
      meta: null,
      defaultBudget: null,
      incomeCategory: null,
      expensesCategory: null,
    }
  },
  async created() {

    let response = await this.$store.dispatch('planExport/loadPlanExport', {
      id: this.$route.params.id,
      lang: this.$i18n.locale
    })

    this.meta = response.data.result.meta[0]
    this.dateExport = response.data.result.data

    let info = await this.$store.dispatch('budget/getAll', this.$route.params.id)

    let mainBudget = info.find((item) => {
      return item.default
    })

    this.loadDefault(mainBudget)
  },
  beforeDestroy() {
    // this.$store.dispatch('planExport/resetProjectExport')
  },
  methods: {

    async loadDefault(budget) {

      this.defaultBudget = await this.$store.dispatch("budget/getSingle", budget.id)

      this.incomeCategory = this.defaultBudget.categories.find((cat) => {
        return cat.name == 'Revenue'
      })

      this.expensesCategory = this.defaultBudget.categories.find((cat) => {
        return cat.name == 'Expenses'
      })
    }
  },
  computed: {

    planName: function () {

      return this.meta ? this.meta.transaction : ''
    }
  }
};
</script>